import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { InfoText, ModalWrapper, TitleWrapper, ButtonRow, Expandable, StyledBackdrop } from "./Styled";
import { StyledButton } from "../../../shared/styled/TitleBar";

interface AlertModalProps {
    text: string;
    open: boolean;
    handleClose: any;
}

export const AlertModal = ({ text, open, handleClose }: AlertModalProps) => {
    const [isOpen, setIsOpen] = useState(open);

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <InfoText>{text}</InfoText>
                    </TitleWrapper>
                </Expandable>

                <ButtonRow>
                    <StyledButton onClick={handleCloseWithAnimation}>Xác nhận</StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
